export const successToastConfig = { autoClose: 6000 };
export const errorToastConfig = { autoClose: 6000 };
export const infoToastConfig = { autoClose: 6000 };
export const warningToastConfig = { autoClose: 6000 };
